/** @jsx jsx */
import { jsx } from 'theme-ui'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import Identifier from './Identifier'
import Img from 'gatsby-image/withIEPolyfill'

const Container = styled.div`
  border-top: 2px solid #000;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
`

const Item = styled.div`
  width: 100%;
  flex: 100%;
  max-width: 100%;
  display: flex;
  align-items: stretch;
  font-size: ${props => props.theme.fontSizes[7]}px;
  line-height: 1em;
  border-bottom: 2px solid #000;
  text-transform: uppercase;
  opacity: 1;

  .shown {
    padding: 15px;
  }

  @media (min-width: ${props => props.theme.responsive.medium}) {
    flex: 0 0 50%;
    max-width: 50%;
    height: 280px;

    &:nth-last-of-type(1),
    &:nth-last-of-type(2) {
      border-bottom: none !important;
    }
    &:nth-of-type(odd) {
      position: relative;
      &:after{
        content:'';
        height: 100%;
        width: 2px;
        background: #000;
        position: absolute;
        top: 0;
        right: 0;
      }
    }

    .shown {
      padding: 60px;
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: ${props => props.theme.responsive.largeMax}) {
    font-size: ${props => props.theme.fontSizes[6]}px;
  }

  @media (max-width: ${props => props.theme.responsive.mediumMax}) {
    border-bottom: 2px solid #000;
    font-size: ${props => props.theme.fontSizes[5]}px;

    &:nth-last-of-type(1) {
      border-bottom: none;
    }
  }

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    font-size: ${props => props.theme.fontSizes[4]}px;
  }

  .hidden {
    display: none;
    opacity: 0;
    width: 100%;
  }

  &:hover .hidden {
    opacity: 1;
    display: inline-block;
  }

  &:hover .shown {
    display: none;
    opacity: 0;
  }
`

const Hidden = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;
  height: 100%;
  width: 100%;

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    flex-flow: row wrap;
  }
`

const HiddenLeft = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  flex: 0 0 30%;
  max-width: 30%;
  min-height: 160px;
  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    flex: 1 0 100%;
    max-width: 100%;
    pointer-events: none;
  }

  img {
    width: 150px;
    height: auto;
  }
`

const HiddenRight = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 0 0 70%;
  max-width: 70%;
  padding: 30px;
  background-color: ${props => props.theme.colors.red};
  color: #000;
  font-size: ${props => props.theme.fontSizes[5]}px;
  line-height: 1.2em;
  border-left: 2px solid #000;

  div{
    width: 100%;
  }

  @media (max-width: ${props => props.theme.responsive.smallMax}) {
    flex: 1 0 100%;
    max-width: 100%;
    border-left: 0;
    border-top: 2px solid #000;
  }

  div:nth-of-type(2) {
    font-size: ${props => props.theme.fontSizes[1]}px;
    line-height: 1.5em;
    text-transform: none;
    margin-top: 5px;
  }

  a {
    margin-top: 15px;
    opacity: 1 !important;
    text-transform: uppercase;
    padding: 5px 15px;
    border: 2px solid #fff;
    display: inline-block;
    border-radius: 999px;
    width: auto;

    &:hover {
      background-color: #fff;
    }
  }
`

const ContentLeistungen = props => {
  return (
    <Container>
      {props.transfer.edges.map(({ node }) => (
        <Item key={`cpl-map-${node.contentful_id}`}>
          <div className="shown">{node.title}</div>
          <div className="hidden">
            <Hidden>
              <HiddenLeft>
                <Link
                  to={
                    node.internal.type === 'ContentfulProdukte'
                      ? `/produkte/${node.slug}/`
                      : `/leistungen/${node.slug}/`
                  }
                >
                  {node.identifier && (
                    <Identifier farbe={node.farbe}>
                      {node.identifier}
                    </Identifier>
                  )}
                  {node.logo && (
                    <Img
                      fixed={node.logo.fixed}
                      alt={node.title}
                      objectFit="cover"
                      objectPosition="50% 50%"
                    />
                  )}
                </Link>
              </HiddenLeft>
              <HiddenRight
                sx={{ bg: `${node.farbe && node.farbe.toLowerCase()}` }}
              >
                <div>{node.title}</div>
                <div>
                  {node.beschreibungSatz &&
                    node.beschreibungSatz.internal.content}
                </div>
                <Link
                  to={
                    node.internal.type === 'ContentfulProdukte'
                      ? `/produkte/${node.slug}/`
                      : `/leistungen/${node.slug}/`
                  }
                >
                  Info
                </Link>
              </HiddenRight>
            </Hidden>
          </div>
        </Item>
      ))}
    </Container>
  )
}

export default ContentLeistungen
